import { GenIcon } from '../helpers/IconBase.es.js';

const NewsOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.8335 11.1667L6.16683 8.75V12.985L2.8335 11.1667Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.1668 11.1667L17.8335 8.75V12.985L21.1668 11.1667Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.16683 8.75L2.8335 11.1667V21.1667H21.1668V11.1667L17.8335 8.75",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.16699 12.9999V2.83325H17.8337V12.9999",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M2.8335 11.1665L21.1668 21.1665",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.1667 11.1665L12 16.1665",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.5 7H14.5",
          stroke: "#82869E",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M9.5 10.3333H14.5",
          stroke: "#82869E",
          strokeWidth: "2",
          strokeMiterlimit: "10",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { NewsOutlined };
